import { render, staticRenderFns } from "./juror_avatar.vue?vue&type=template&id=2c73a3c5&scoped=true"
import script from "./juror_avatar.vue?vue&type=script&lang=js"
export * from "./juror_avatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c73a3c5",
  null
  
)

export default component.exports